import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Holiday } from '@classes/holiday/holiday';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {
  holidaysListChanged = new Subject<Holiday[]>();
  private baseUrl: string = environment.apiUrl + 'holidays';
  private groupUrl: string = environment.apiUrl + 'holiday-groups';
  private holidays: Holiday[] = [];

  constructor(
    private http: HttpClient
  ) { }

  get(id: string): Observable<Holiday[]> {
    return this.http.get<Holiday[]>(`${this.groupUrl}/${id}/holidays`)
      .pipe(
        map(holidays => {
          this.holidays = holidays.map(c => Holiday.fromObject(c));
          this.holidaysListChanged.next([...this.holidays]);
          return [...this.holidays];
        })
      );
  }

  put(holiday: Holiday): Observable<Holiday> {
    return this.http.put<Holiday>(this.baseUrl, holiday)
      .pipe(
        tap(editedHolday => {
          editedHolday = Holiday.fromObject(editedHolday);
          this.holidays = this.holidays.map(c => c.id === editedHolday.id ? editedHolday : c);
          this.holidaysListChanged.next([...this.holidays]);
        })
      );
  }

  post(holiday: Holiday): Observable<Holiday> {
    return this.http.post<Holiday>(this.baseUrl, holiday)
      .pipe(
        tap(createdHoliday => {
          createdHoliday = Holiday.fromObject(createdHoliday);
          this.holidays.push(createdHoliday);
          this.holidaysListChanged.next([...this.holidays]);
        })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
        tap(() => {
          this.holidays = this.holidays.filter(c => c.id !== id);
          this.holidaysListChanged.next([...this.holidays]);
        })
      );
  }
}
